import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { className as classNameFnc } from 'design-system';

import style from './style.module.scss';

export default function FrameImageComponent({
    image,
    className,
    aspectRatio,
    desktopAspectRatio,
    type,
}) {
    const hasDesktopAspectRatio =
        desktopAspectRatio && desktopAspectRatio !== aspectRatio;

    return (
        <div
            {...classNameFnc(
                `${style.wrapper} ${type ? style[`wrapper--${type}`] : ''} ${
                    className ? className : ''
                }`,
            )}>
            <div
                {...classNameFnc(
                    `${style.image} ${
                        hasDesktopAspectRatio ? 'd-lg-none' : ''
                    }`,
                )}
                style={{
                    paddingTop: `${aspectRatio * 100}%`,
                }}>
                {image?.gatsbyImageData ? (
                    <GatsbyImage
                        alt={image?.alt || ''}
                        image={image.gatsbyImageData}
                    />
                ) : null}
            </div>
            {hasDesktopAspectRatio ? (
                <div
                    {...classNameFnc(`${style.image} d-none d-lg-block`)}
                    style={{
                        paddingTop: `${desktopAspectRatio * 100}%`,
                    }}>
                    {image?.gatsbyImageData ? (
                        <GatsbyImage
                            alt={image?.alt || ''}
                            image={image.gatsbyImageData}
                        />
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}
